import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useProfiles } from "../profiles/ProfileContext";
import { Button } from "../components/ui/Button";
import { PageHeader } from "../components/Surface";
import { ListRow } from "../components/ListTable";
import { Results, ItemCard } from "../components/Paged";
import { labelize } from "../lib/format";
import { myLoads, rateLabel, laneLabel, LOAD_POST_TYPES, type MyLoad } from "../lib/loads";

export function MyLoads() {
  const { active } = useProfiles();
  const isPoster = active ? LOAD_POST_TYPES.includes(active.type) : false;
  const [loads, setLoads] = useState<MyLoad[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!active || !isPoster) {
      setLoading(false);
      return;
    }
    myLoads(active.id).then((r) => setLoads(r.loads)).finally(() => setLoading(false));
  }, [active, isPoster]);

  return (
    <div className="grid gap-6">
      <PageHeader
        title="My loads"
        subtitle="Your posted shipments and bid activity."
        actions={<Link to="/loads/new"><Button>Post a shipment</Button></Link>}
      />
      {!isPoster ? (
        <p className="text-sm text-muted">Switch to a broker/dispatcher or company profile to see your loads.</p>
      ) : loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : (
        <Results
          items={loads}
          perPage={12}
          defaultView="list"
          listColumns={["Shipment", "Status", "Bids"]}
          gridClass="grid gap-3 sm:grid-cols-2 lg:grid-cols-3"
          empty={<p className="font-mono text-sm text-muted">You haven't posted any loads yet.</p>}
          renderRow={(l) => (
            <ListRow key={l.id} to={`/loads/${l.id}`} title={laneLabel(l.origin, l.destination)} meta={[rateLabel(l.rate, l.rate_type), labelize(l.equipment_type)].filter(Boolean).join(" · ")} status={l.status} right={`${l.bid_count} bid${l.bid_count === 1 ? "" : "s"}`} />
          )}
          renderCard={(l) => (
            <ItemCard key={l.id} to={`/loads/${l.id}`} title={laneLabel(l.origin, l.destination)} meta={[rateLabel(l.rate, l.rate_type), labelize(l.equipment_type)].filter(Boolean).join(" · ")} status={l.status} right={`${l.bid_count} bid${l.bid_count === 1 ? "" : "s"}`} />
          )}
        />
      )}
    </div>
  );
}
